import { Wrapper } from "../../layout";
import BaseRadioInput from "../BaseRadioInput";

export default function LanguageRadioInput({languageDefault, updateLanguage}) {

  return (
    <Wrapper gap={"1rem"} position={"middle-center"}>
      <BaseRadioInput
        id={"bp-checked-radio"}
        name={"BPChecked"}
        bold={false}
        handleChange={event =>updateLanguage(event.target.value)}
        optionsFlow="horizontal"
        options={[
          {
            label: "English",
            value: "en",
            defaultValue:languageDefault === "en"
          },
          {
            label: "Español",
            value: "es",
            defaultValue:languageDefault === "es"
          },
          {
            label: "Português",
            value: "pt",
            defaultValue:languageDefault === "pt"
          },
        ]}
      />
    </Wrapper>
  );
}
